import React from 'react';

const MapContext = React.createContext(undefined);
MapContext.displayName = "MapContext";

const MapViewContext = React.createContext(undefined);
MapViewContext.displayName = "MapViewContext";

export { MapContext, MapViewContext };